import { useEffect, useState } from 'react';

/**
 * Returns the current `Date` object and re‑emits it every `stepMs`.
 * Default step = 30 000 ms → UI refreshes roughly every half‑minute.
 */
export function useNow(stepMs: number = 30_000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), stepMs);
    return () => clearInterval(id);        // ✅ cleanup on unmount
  }, [stepMs]);

  return now;
}
